import { createFileRoute } from "@tanstack/react-router";
import BCBSFederalDepressionInfoSession from "@/pages/BCBSFederalDepressionInfoSession";
export const Route = createFileRoute("/bcbs-federal-depression-info-session")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Federal Depression Info Session | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "BCBS Federal Employee Program members and families can learn about newer depression treatment options and potential insurance benefits in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "BCBS Federal Depression Info Session | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "BCBS Federal Employee Program members and families can learn about newer depression treatment options and potential insurance benefits in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/bcbs-federal-depression-info-session",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbs-federal-depression-info-session",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BCBSFederalDepressionInfoSession />;
}
